import React from 'react'; 
import dotIcon from '../hybridImages/Circle.png';
import { DropDownButton } from '@progress/kendo-react-buttons';

const BankBalanceItem = (props) => { 
    const {item, isFromPreview} = props;

    const btnItems = [
        "Edit",
        "Remove"
    ]

    const options = {
        maximumFractionDigits: 2
    }    
    
    const decimalRegex = new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/);
    const numericRegex = new RegExp(/^[0-9]+$/);
    const add0 = (a) => {
        let r = '';
        let b = Intl.NumberFormat("en-US", options).format(a);
        if (decimalRegex.test(a) || numericRegex.test(a)) {

            let dpoint = b.indexOf(".") + 1;
            let gap = b.length - dpoint;
            if (gap == 1 && b.length > 1) {
                r = b + '0';
            } else if (dpoint == 0) {
                r = b + '.00';
            } else {
                r = b;
            }
        } else {
            r = b;

        }
        return r;
    }

    return (
        <div className="row around-xs inputPair" >
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='bank-balance-col1 item-float-left div-wrap-text'>
                    {item.bankName.label}
                </div>
                <div className='bank-balance-col2 item-float-left div-wrap-text'>
                    {item.accountNumber}
                </div>

                {/* {(isFromPreview === true)&&
                    <div className='bank-balance-col5 item-float-left'>
                        {item.currency.value}
                    </div>
                } */}
                <div className='bank-balance-col4 item-float-left'>
                    {item.currency.value+' '+add0(item.sixMonthsBalanceAmt)}
                </div>

                {/* <div className='bank-balance-col3 item-float-left'>
                 {item.balanceHistory.map((k, i)=> (
                    <div key={i}>{k.date}</div>
                 ))}
                </div>
                <div className='bank-balance-col4 item-float-left'>
                    {item.balanceHistory.map((k, i)=> (
                        <div key={i}>{item.currency.value+' '}{k.monthEndBal}</div>
                    ))} 
                </div>*/}
                {(isFromPreview === false)&&
                <div className='bank-balance-col5 item-float-left' style={{marginTop:'-10px'}} >
                    <DropDownButton 
                        fillMode={"flat"}
                        imageUrl={dotIcon}
                        items={btnItems}
                        onItemClick={(e) => {
                            // console.log('onItemClick',e);
                            if(e.item === btnItems[0]) { //edit
                                //edit
                                props.onClick('EDIT');
                                return;
                            }

                            if(e.item === btnItems[1]) { //DELETE
                                //delete the file first, remove from the list
                                props.onClick('REMOVE');
                                return;
                            }
                        }}
                    /> 
                </div>
                }
           </div>
        </div>
    )
}
export default BankBalanceItem;